/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Send to Onshape Part Studio</h4>

<p>Send your model to Onshape as a Part Studio.</p>`;

export default function SendToOnshapeTooltip() {
    return h('div', { innerHTML: body });
}
